// @flow

import React from 'react';
import styled from 'styled-components';

import { CompanyInfo } from 'components/Global/Footer/shared';
import { buttonDefault, Color, flex, hover, maxWidthContainer, Width } from 'styles';
import { Nav as NavData } from 'data/global/nav';
import { Location } from '@reach/router';
import { Link } from 'components/Gui';

const Container = styled.div`
  ${maxWidthContainer(Width.XL)};
  margin-top: auto;
  padding: 42px 0 42px 0;
  position: relative;
  display: flex;
  flex-direction: column;

  @media print, screen and (min-width: ${Width.BREAK_MD}px) {
    padding: 34px 0 72px 0;
  }

  p {
    color: white;
  }
`;

const Nav = styled.div`
  ${flex('flex-start', 'flex-start')};
  border-top: 1px solid ${Color.MARKETS_RED};
  border-bottom: 1px solid ${Color.MARKETS_RED};
  padding: 24px 0;
  margin: 24px 0;
  flex-wrap: wrap;

  @media (min-width: ${Width.BREAK_MD}px) {
    ${flex()};
  }

  a.link {
    ${buttonDefault};
    position: relative;
    margin-right: 32px;
    margin-bottom: 10px;
    ${hover('color', Color.WHITE, Color.MARKETS_RED)};

    @media (min-width: ${Width.BREAK_MD}px) {
      margin-bottom: 0;
    }
  }

  a.link.active {
    color: ${Color.MARKETS_RED} !important;
  }

  a.link.external {
    ${hover('color', Color.MARKETS_GREEN, Color.WHITE)};
  }
`;

const Footer = () => (
  <Container>
    <CompanyInfo />
    <Nav>
      {NavData.map(({ title, url }, index) => (
        <Location key={`MenuNav-${index}`}>
          {({ location: { pathname } }) => (
            <Link className={url.includes('http') ? 'link external' : `link${pathname === url ? ' active' : ''}`} url={url}>
              {title}
            </Link>
          )}
        </Location>
      ))}
    </Nav>
    <p>
      <strong>Licences and Authorisations</strong>
      {`
Markets Direct is a brand of Triton Capital Markets Limited which holds an Investment Service Category 3 License and is regulated by the Malta Financial Services Authority (MFSA) of Notabile Road, Attard, Bkr3000, Malta MFSA IS/48817

`}
      <strong>Risk Warning</strong>
      {`
      CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. 75% of retail investor accounts lose money when trading CFDs with Triton Capital Markets Limited You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.

`}
      <strong>High Risk Warning</strong>
      {`
Foreign exchange trading carries a high level of risk that may not be suitable for all investors. Leverage creates additional risk and loss exposure. Before you decide to trade foreign exchange, carefully consider your investment objectives, experience level, and risk tolerance. You could lose some or all of your initial investment; do not invest money that you cannot afford to lose. Educate yourself on the risks associated with foreign exchange trading, and seek advice from an independent financial or tax advisor if you have any questions.

`}
      <strong>Advisory Warning</strong>
      {`
Triton Capital Markets Limited provides references and links to selected blogs and other sources of economic and market information as an educational service to its clients and prospects and does not endorse the opinions or recommendations of the blogs or other sources of information. Clients and prospects are advised to carefully consider the opinions and analysis offered in the blogs or other information sources in the context of the client or prospect's individual analysis and decision making. None of the blogs or other sources of information is to be considered as constituting a track record. Past performance is no guarantee of future results and Triton Capital Markets Limited specifically advises clients and prospects to carefully review all claims and representations made by advisors, bloggers, money managers and system vendors before investing any funds or opening an account with any Forex dealer. Any news, opinions, research, data, or other information contained within this website is provided as general market commentary and does not constitute investment or trading advice. Triton Capital Markets Limited expressly disclaims any liability for any lost principal or profits without limitation which may arise directly or indirectly from the use of or reliance on such information. As with all such advisory services, past results are never a guarantee of future results.


Markets Direct © 2004 - 2020
K2, First Floor, Forni Complex, Valletta Waterfront, Floriana, FRN 1913 Malta`}
    </p>
  </Container>
);

export default Footer;
